import SiteHeader from './components/site-header';
// import NewsSlider from './components/news-slider';
// import ReviewsSlider from './components/reviews-slider';
// import PartnersSlider from './components/partners-slider';
// import PortalPageSlider from './components/portal-page-slider';
import HandheldMenu from './components/handheld-menu';
// import DesktopMenu from './components/desktop-menu';
import CookiesConsent from './components/cookies-consent';
// import DropdownMenu from './components/dropdown-menu';
// import Accordion from './components/accordion';
// import EventsSlider from './components/events-slider';
// import NewsletterForm from './components/newsletter-form';
import DeviceManager from './utils/device-manager';
// import TableHide from './components/table-hide';
// import Sharebar from './components/sharebar';
// import EstateSlider from './components/estate-slider';

const onDOMReady = () => {
	const bootstrapApp = () => {
		const html = document.querySelector('html');

		// Touch device detection
		if(DeviceManager.isHandheld()) {
			html.classList.add('touch');

			if(DeviceManager.isIos()) {
				html.classList.add('ios');
			}
		} 
        else {
			html.classList.add('no-touch');
		}

		// IE detection
		if(DeviceManager.isIe11()) {
			html.classList.add('ie11');
		} 
        else if(DeviceManager.isEdge()) {
			html.classList.add('edge');
		}
	};

	const instanciateComponents = async () => {
		// Header
		const siteHeader = new SiteHeader(document.querySelector('.site-header'));

		// // Home slider component
		// const featuredProjectsSlider = document.querySelector('.featured-projects-slider');
		// if (featuredProjectsSlider) {
        //     import(/* webpackChunkName: "featured-projects-slider" */ './components/featured-projects-slider').then((FeaturedProjectsSlider) => {
        //         const slider = new FeaturedProjectsSlider.default(featuredProjectsSlider.parentNode);
        //     });
		// }

        // // Sentence reveal component
        // const sentence = document.querySelector('.sentence-reveal');
        // if (sentence) {
        //     import(/* webpackChunkName: "sentence-reveal" */ './components/sentence-reveal').then((SentenceReveal) => {
        //         const sentenceReveal = new SentenceReveal.default(sentence);
        //     });
        // }

        // // Services list component
        // const servicesLists = [...document.querySelectorAll('.services-list')];
        // if (servicesLists.length) {
        //     import(/* webpackChunkName: "services-list" */ './components/services-list').then((ServicesList) => {
        //         servicesLists.forEach((servicesList) => {
        //             const list = new ServicesList.default(servicesList);
        //         })
        //     });
        // }

        // Events list component
        const eventsList = document.querySelector('.events-list');
        const eventsFilters = document.querySelector('.events-filters');
        if (eventsList && eventsFilters) {
            import(/* webpackChunkName: "events-list" */ './components/events-list').then((EventsList) => {
                const list = new EventsList.default(eventsList, eventsFilters);
            });
        }

        // Accordion component
        const accordions = [...document.querySelectorAll('.accordion')];
        if (accordions.length) {
            import(/* webpackChunkName: "accordion" */ './components/accordion').then((Accordion) => {
                accordions.forEach((accordion) => {
                    const instance = new Accordion.default(accordion);
                });
            });
        }

        // Related projects slider component
        const eventsSliders = [...document.querySelectorAll('.events-slider')];
        if (eventsSliders.length) {
            import(/* webpackChunkName: "events-slider" */ './components/events-slider').then((EventsSlider) => {
                eventsSliders.forEach((eventsSlider) => {
                    const slider = new EventsSlider.default(eventsSlider);
                });
            });
        }

        // // Project details popup component
        // const projectDetailsPopup = document.querySelector('.project__details-popup');
        // const projectsDetailsButton = document.querySelector('.project__details-button');
        // if (projectDetailsPopup && projectsDetailsButton) {
        //     import(/* webpackChunkName: "project-details-popup" */ './components/project-details-popup').then((ProjectDetailsPopup) => {
        //         const popup = new ProjectDetailsPopup.default(projectDetailsPopup, projectsDetailsButton);
        //     });
        // }

		// Cookie consent
		if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = 'fr';

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}
	};

	bootstrapApp;
	instanciateComponents();
};

if(document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', onDOMReady);
}
else {
    onDOMReady();
}

